"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnOptionLabels = columnOptionLabels;
exports.relationRowIds = relationRowIds;
exports.cellToText = cellToText;
const database_identity_1 = require("@streamlain/database-identity");
const text_1 = require("./text");
function namedText(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return null;
    const record = value;
    for (const key of ['insert', 'text', 'value', 'label', 'name', 'title']) {
        const nested = record[key];
        if (typeof nested === 'string' && nested.trim())
            return nested;
    }
    return null;
}
function nestedText(value) {
    if (value === null || value === undefined)
        return '';
    if (typeof value === 'string')
        return value;
    if (typeof value === 'number' || typeof value === 'boolean') {
        return String(value);
    }
    const named = namedText(value);
    if (named)
        return named;
    if (Array.isArray(value))
        return value.map(nestedText).join('');
    if (typeof value === 'object') {
        return Object.values(value)
            .map(nestedText)
            .filter(Boolean)
            .join(' ');
    }
    return '';
}
/** Option labels of a select column, by option id. */
function columnOptionLabels(column) {
    const labels = new Map();
    const options = column.data?.options;
    if (!Array.isArray(options))
        return labels;
    for (const option of options) {
        if (!option || typeof option !== 'object')
            continue;
        const { id, value } = option;
        if (typeof id === 'string' && typeof value === 'string') {
            labels.set(id, value);
        }
    }
    return labels;
}
function optionText(value, column) {
    const named = namedText(value);
    if (named)
        return named;
    if (typeof value !== 'string')
        return '';
    return columnOptionLabels(column).get(value) ?? '';
}
function relationRowIds(value) {
    if (typeof value === 'string')
        return [value];
    if (Array.isArray(value))
        return value.flatMap(relationRowIds);
    if (!value || typeof value !== 'object')
        return [];
    const record = value;
    const id = record.id ?? record.rowId;
    return typeof id === 'string' ? [id] : [];
}
/** The single rule for the search text of a database cell. */
function cellToText(column, value, context = {}) {
    if (value === null || value === undefined)
        return '';
    switch (column.type) {
        case 'title':
        case 'rich-text':
        case 'text':
            return (0, text_1.plainText)(value);
        case 'attachment':
        case 'file':
        case 'image':
        case 'progress':
            // File text comes from file extraction, not from the cell.
            return '';
        case 'number':
            return String(value);
        case 'date':
            return value instanceof Date
                ? value.toISOString().split('T')[0]
                : String(value);
        case 'select':
            return optionText(value, column);
        case 'multi-select':
            return Array.isArray(value)
                ? value
                    .map(item => optionText(item, column))
                    .filter(Boolean)
                    .join(', ')
                : optionText(value, column);
        case 'checkbox':
            return (0, database_identity_1.databaseSearchCellText)(value);
        case 'relation': {
            const labels = context.relationLabels;
            if (!labels)
                return '';
            return relationRowIds(value)
                .map(rowId => labels[rowId])
                .filter((label) => !!label)
                .join(', ');
        }
        default:
            return nestedText(value).trim();
    }
}
//# sourceMappingURL=cell-text.js.map